import styled from 'styled-components';

import colors from '../../../../../../../styles/colors';

const TooltipRow = styled.div`
  display: flex;
  gap: 12px;
  font-size: 12px;
  line-height: 20px;
`;

const TooltipLabel = styled.span`
  min-width: 50px;
  color: ${colors.shades.gamma9};
`;

const TooltipHeader = styled(TooltipRow)`
  font-weight: 600;
  border-bottom: 1px solid ${colors.base.alpha};
  margin-bottom: 2px;
  padding-bottom: 2px;
`;

export {
  TooltipRow,
  TooltipLabel,
  TooltipHeader,
};
